/**
 * @fileoverview gRPC-Web generated client stub for witbooking.backoffice.bundle.v1
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');


var validate_validate_pb = require('../../../../validate/validate_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.witbooking = {};
proto.witbooking.backoffice = {};
proto.witbooking.backoffice.bundle = {};
proto.witbooking.backoffice.bundle.v1 = require('./package_api_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.bundle.v1.PackageAPIClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.bundle.v1.PackageAPIPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.bundle.v1.CreatePackageRequest,
 *   !proto.witbooking.backoffice.bundle.v1.CreatePackageResponse>}
 */
const methodDescriptor_PackageAPI_CreatePackage = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.bundle.v1.PackageAPI/CreatePackage',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.bundle.v1.CreatePackageRequest,
  proto.witbooking.backoffice.bundle.v1.CreatePackageResponse,
  /**
   * @param {!proto.witbooking.backoffice.bundle.v1.CreatePackageRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.bundle.v1.CreatePackageResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.bundle.v1.CreatePackageRequest,
 *   !proto.witbooking.backoffice.bundle.v1.CreatePackageResponse>}
 */
const methodInfo_PackageAPI_CreatePackage = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.bundle.v1.CreatePackageResponse,
  /**
   * @param {!proto.witbooking.backoffice.bundle.v1.CreatePackageRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.bundle.v1.CreatePackageResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.bundle.v1.CreatePackageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.bundle.v1.CreatePackageResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.bundle.v1.CreatePackageResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.bundle.v1.PackageAPIClient.prototype.createPackage =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.bundle.v1.PackageAPI/CreatePackage',
      request,
      metadata || {},
      methodDescriptor_PackageAPI_CreatePackage,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.bundle.v1.CreatePackageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.bundle.v1.CreatePackageResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.bundle.v1.PackageAPIPromiseClient.prototype.createPackage =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.bundle.v1.PackageAPI/CreatePackage',
      request,
      metadata || {},
      methodDescriptor_PackageAPI_CreatePackage);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.bundle.v1.UpdatePackageRequest,
 *   !proto.witbooking.backoffice.bundle.v1.UpdatePackageResponse>}
 */
const methodDescriptor_PackageAPI_UpdatePackage = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.bundle.v1.PackageAPI/UpdatePackage',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.bundle.v1.UpdatePackageRequest,
  proto.witbooking.backoffice.bundle.v1.UpdatePackageResponse,
  /**
   * @param {!proto.witbooking.backoffice.bundle.v1.UpdatePackageRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.bundle.v1.UpdatePackageResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.bundle.v1.UpdatePackageRequest,
 *   !proto.witbooking.backoffice.bundle.v1.UpdatePackageResponse>}
 */
const methodInfo_PackageAPI_UpdatePackage = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.bundle.v1.UpdatePackageResponse,
  /**
   * @param {!proto.witbooking.backoffice.bundle.v1.UpdatePackageRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.bundle.v1.UpdatePackageResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.bundle.v1.UpdatePackageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.bundle.v1.UpdatePackageResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.bundle.v1.UpdatePackageResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.bundle.v1.PackageAPIClient.prototype.updatePackage =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.bundle.v1.PackageAPI/UpdatePackage',
      request,
      metadata || {},
      methodDescriptor_PackageAPI_UpdatePackage,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.bundle.v1.UpdatePackageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.bundle.v1.UpdatePackageResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.bundle.v1.PackageAPIPromiseClient.prototype.updatePackage =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.bundle.v1.PackageAPI/UpdatePackage',
      request,
      metadata || {},
      methodDescriptor_PackageAPI_UpdatePackage);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.bundle.v1.DeletePackageRequest,
 *   !proto.witbooking.backoffice.bundle.v1.DeletePackageResponse>}
 */
const methodDescriptor_PackageAPI_DeletePackage = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.bundle.v1.PackageAPI/DeletePackage',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.bundle.v1.DeletePackageRequest,
  proto.witbooking.backoffice.bundle.v1.DeletePackageResponse,
  /**
   * @param {!proto.witbooking.backoffice.bundle.v1.DeletePackageRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.bundle.v1.DeletePackageResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.bundle.v1.DeletePackageRequest,
 *   !proto.witbooking.backoffice.bundle.v1.DeletePackageResponse>}
 */
const methodInfo_PackageAPI_DeletePackage = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.bundle.v1.DeletePackageResponse,
  /**
   * @param {!proto.witbooking.backoffice.bundle.v1.DeletePackageRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.bundle.v1.DeletePackageResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.bundle.v1.DeletePackageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.bundle.v1.DeletePackageResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.bundle.v1.DeletePackageResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.bundle.v1.PackageAPIClient.prototype.deletePackage =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.bundle.v1.PackageAPI/DeletePackage',
      request,
      metadata || {},
      methodDescriptor_PackageAPI_DeletePackage,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.bundle.v1.DeletePackageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.bundle.v1.DeletePackageResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.bundle.v1.PackageAPIPromiseClient.prototype.deletePackage =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.bundle.v1.PackageAPI/DeletePackage',
      request,
      metadata || {},
      methodDescriptor_PackageAPI_DeletePackage);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.bundle.v1.ReorderPackageRequest,
 *   !proto.witbooking.backoffice.bundle.v1.ReorderPackageResponse>}
 */
const methodDescriptor_PackageAPI_ReorderPackage = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.bundle.v1.PackageAPI/ReorderPackage',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.bundle.v1.ReorderPackageRequest,
  proto.witbooking.backoffice.bundle.v1.ReorderPackageResponse,
  /**
   * @param {!proto.witbooking.backoffice.bundle.v1.ReorderPackageRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.bundle.v1.ReorderPackageResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.bundle.v1.ReorderPackageRequest,
 *   !proto.witbooking.backoffice.bundle.v1.ReorderPackageResponse>}
 */
const methodInfo_PackageAPI_ReorderPackage = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.bundle.v1.ReorderPackageResponse,
  /**
   * @param {!proto.witbooking.backoffice.bundle.v1.ReorderPackageRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.bundle.v1.ReorderPackageResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.bundle.v1.ReorderPackageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.bundle.v1.ReorderPackageResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.bundle.v1.ReorderPackageResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.bundle.v1.PackageAPIClient.prototype.reorderPackage =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.bundle.v1.PackageAPI/ReorderPackage',
      request,
      metadata || {},
      methodDescriptor_PackageAPI_ReorderPackage,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.bundle.v1.ReorderPackageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.bundle.v1.ReorderPackageResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.bundle.v1.PackageAPIPromiseClient.prototype.reorderPackage =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.bundle.v1.PackageAPI/ReorderPackage',
      request,
      metadata || {},
      methodDescriptor_PackageAPI_ReorderPackage);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.bundle.v1.GetPackageRequest,
 *   !proto.witbooking.backoffice.bundle.v1.GetPackageResponse>}
 */
const methodDescriptor_PackageAPI_GetPackage = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.bundle.v1.PackageAPI/GetPackage',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.bundle.v1.GetPackageRequest,
  proto.witbooking.backoffice.bundle.v1.GetPackageResponse,
  /**
   * @param {!proto.witbooking.backoffice.bundle.v1.GetPackageRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.bundle.v1.GetPackageResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.bundle.v1.GetPackageRequest,
 *   !proto.witbooking.backoffice.bundle.v1.GetPackageResponse>}
 */
const methodInfo_PackageAPI_GetPackage = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.bundle.v1.GetPackageResponse,
  /**
   * @param {!proto.witbooking.backoffice.bundle.v1.GetPackageRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.bundle.v1.GetPackageResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.bundle.v1.GetPackageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.bundle.v1.GetPackageResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.bundle.v1.GetPackageResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.bundle.v1.PackageAPIClient.prototype.getPackage =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.bundle.v1.PackageAPI/GetPackage',
      request,
      metadata || {},
      methodDescriptor_PackageAPI_GetPackage,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.bundle.v1.GetPackageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.bundle.v1.GetPackageResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.bundle.v1.PackageAPIPromiseClient.prototype.getPackage =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.bundle.v1.PackageAPI/GetPackage',
      request,
      metadata || {},
      methodDescriptor_PackageAPI_GetPackage);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.bundle.v1.GetPackagesRequest,
 *   !proto.witbooking.backoffice.bundle.v1.GetPackagesResponse>}
 */
const methodDescriptor_PackageAPI_GetPackages = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.bundle.v1.PackageAPI/GetPackages',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.bundle.v1.GetPackagesRequest,
  proto.witbooking.backoffice.bundle.v1.GetPackagesResponse,
  /**
   * @param {!proto.witbooking.backoffice.bundle.v1.GetPackagesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.bundle.v1.GetPackagesResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.bundle.v1.GetPackagesRequest,
 *   !proto.witbooking.backoffice.bundle.v1.GetPackagesResponse>}
 */
const methodInfo_PackageAPI_GetPackages = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.bundle.v1.GetPackagesResponse,
  /**
   * @param {!proto.witbooking.backoffice.bundle.v1.GetPackagesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.bundle.v1.GetPackagesResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.bundle.v1.GetPackagesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.bundle.v1.GetPackagesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.bundle.v1.GetPackagesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.bundle.v1.PackageAPIClient.prototype.getPackages =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.bundle.v1.PackageAPI/GetPackages',
      request,
      metadata || {},
      methodDescriptor_PackageAPI_GetPackages,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.bundle.v1.GetPackagesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.bundle.v1.GetPackagesResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.bundle.v1.PackageAPIPromiseClient.prototype.getPackages =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.bundle.v1.PackageAPI/GetPackages',
      request,
      metadata || {},
      methodDescriptor_PackageAPI_GetPackages);
};


module.exports = proto.witbooking.backoffice.bundle.v1;

